import { styled } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";

export const Button = styled(MuiButton)((props) => ({
    borderRadius: '20px',
    width: 'inherit',
    minWidth: '100px',
}));
